<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <m-search-item label="关键字搜索">
                    <c-input name="keyword" maxlength="50" placeholder="联系人/手机号/店铺名"></c-input>
                </m-search-item>
                <m-search-item label="跟进状态" >
                    <c-select name="follow_state" multiple :options="SAAS_FOLLOW_STATE"></c-select>
                </m-search-item>
            </m-search>

            <c-table ref="list" height="grow" :paging="true">
                <c-table-column
                        label="店铺/公司名称"
                        name="shop_name"
                        width="180"
                >
                </c-table-column>

                <c-table-column
                        label="联系人"
                        name="contact_person"
                        width="80"
                >
                </c-table-column>

                <c-table-column
                        label="联系手机"
                        name="contact_phone"
                        width="100"
                >
                </c-table-column>

                <c-table-column
                        label="团队规模"
                        name="team_size"
                        width="80"
                >
                    <template #default="{data}">
                        <c-state tag async dict="SAAS_TEAM_SIZE" :value="data.team_size"></c-state>
                    </template>
                </c-table-column>

                <c-table-column
                        label="跟进状态"
                        name="follow_state"
                        width="80"

                >
                    <template #default="{data}">
                        <c-state tag async dict="SAAS_FOLLOW_STATE" :value="data.follow_state"></c-state>
                    </template>
                </c-table-column>

                <c-table-column
                        label="跟进人"
                        name="follow_user_name"
                        width="80"
                >
                    <template #default="{data}">
                        <span v-if="data.follow_user_name">{{data.follow_user_name}}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="最后跟进时间"
                        name="follow_date"
                        width="140"
                >
                    <template #default="{data}">
                        <span v-if="data.follow_date">{{data.follow_date}}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="跟进备注"
                        name="follow_remark"
                        width="200"
                >
                    <template #default="{data}">
                        <span v-if="data.follow_remark">{{data.follow_remark}}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="注册来源"
                        name="register_source"
                        width="90"
                >
                    <template #default="{data}">
                        <c-state tag dict="registerSourceDic" :value="data.register_source"></c-state>
                    </template>
                </c-table-column>

                <c-table-column
                        label="申请时间"
                        name="create_date"
                        width="140"
                >
                </c-table-column>

                <c-table-column
                        type="button"
                        label="操作"
                        width="200"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_saas_apply_detail')" icon="tf-detail" @click="$refs.saasApplyDetail.open(data)">查看详情</c-table-button>
                        <c-table-button v-if="auth('b_saas_apply_follow') && (data.follow_state == 1 || data.follow_state == 2)" icon="tf-add" @click="openFollow(data)">新增跟进</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
            <!--申请详情弹窗-->
            <saas-apply-detail ref="saasApplyDetail"></saas-apply-detail>
            <!--新增跟进弹框-->
            <c-dialog ref="followDialog" width="500" @resolve="followHandle">
                <c-form ref="followForm" unit-width="100%">
                    <c-form-item label="跟进状态" required>
                        <c-radio-group name="follow_state" :options="SAAS_FOLLOW_STATE" :clear="false"></c-radio-group>
                    </c-form-item>
                    <c-form-item label="跟进备注">
                        <c-input type="textarea" name="follow_remark" maxlength="500" placeholder="请输入跟进备注信息"></c-input>
                    </c-form-item>
                </c-form>
            </c-dialog>

        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import {asyncMapState} from '@/store'
import saasApplyDetail from "@/pages/saas/saas_apply_detail.vue";
import saasApplyOpen from "@/pages/saas/saas_apply_open.vue";

export default {
    components: {
        saasApplyDetail,
        saasApplyOpen
    },
    computed: {
        ...mapState(['registerSourceDic']),
        ...asyncMapState(['SAAS_FOLLOW_STATE'])
    },

    data() {
        return {
            followApplyData: null,
        }
    },

    mounted() {
        this.searchHandle();
    },

    methods: {
        /********搜索************/
        searchHandle(data) {
            if (!data) {
                data = {};
            }
            this.$refs.list.load({
                url: '/sys_saas/apply/list',
                data
            });
        },

        /******打开新增跟进弹框*******/
        openFollow(data) {
            this.followApplyData = data;
            this.$refs.followForm.clear();
            this.$refs.followForm.set({follow_state: 2});
            this.$refs.followDialog.open({
                title: '新增跟进 - ' + data.shop_name
            });
        },

        /******提交跟进记录*******/
        followHandle(stop, next) {
            stop();
            this.$refs.followForm.submit({
                url: '/sys_saas/apply/follow',
                rule: {
                    follow_state: '请选择跟进状态'
                },
                dataFormatter: (data) => {
                    data.id = this.followApplyData.id;
                    return data;
                },
                success: () => {
                    next();
                    this.$message({
                        message: '跟进记录保存成功',
                        type: 'success'
                    });
                    this.$refs.list.update();
                }
            });
        },


    }
}
</script>

<style lang="stylus" scoped>
</style>
